export interface AppColors {
  default: string
  primary: string
  info: string
  danger: string
  orange: string
  teal: string
  primaryGradient: string[]
  purpleGradient: string[]
}

export interface OAuth2Config {
  clientId: string
  redirectUri: string
  authServerBase: string
  scopes: string
}

export interface AppConfig {
  colors: AppColors
  oauth2: OAuth2Config
}

const config: AppConfig = {
  colors: {
    default: "#1b2b57",
    primary: "#4f7cff",
    info: "#4f7cff",
    danger: "#fd5d93",
    orange: "#ff8a76",
    teal: "#00d6b4",
    primaryGradient: [
      "rgba(79, 124, 255, 0.2)",
      "rgba(79, 124, 255, 0.1)",
      "rgba(79, 124, 255, 0)",
      "rgba(79, 124, 255, 0)",
    ],
    purpleGradient: ["rgba(253,93,147,0.8)", "rgba(253,93,147,0)"],
  },
  oauth2: {
    clientId: import.meta.env.VITE_OAUTH2_CLIENT_ID,
    redirectUri: import.meta.env.VITE_OAUTH2_REDIRECT_URI,
    authServerBase: import.meta.env.VITE_AUTH_SERVER_BASE,
    scopes: import.meta.env.VITE_OAUTH2_SCOPES,
  },
}

export default config
